<mat-sidenav-container class="sidenav-container" hasBackdrop="false">
  <mat-sidenav [(opened)]="appService.devSidenavOpened" mode="side" position="start">
    <div class="dev-sidenav">
      <div class="sidenav-section top">
        <div class="title-bar" (click)="toggleDev()">Dev Console</div>
        <div class="sub-bar"></div>
      </div>
      <div class="router-shadow-a"></div>
      <mat-divider></mat-divider>
    </div>
  </mat-sidenav>
  <mat-sidenav-content #mainSidenavContent>
    <mat-sidenav-container class="sidenav-container" hasBackdrop="true">
      <mat-sidenav [(opened)]="appService.userSidenavOpened" mode="over" position="end">
        <div class="user-sidenav">
          <div class="sidenav-section top">
            <div class="user-profile-section">
              <div class="user-profile-section-left">
                <label class="font-weight-bold">{{ currentUser?.firstName }} {{ currentUser?.lastName }}</label>
                <label class="email-link"><span class="dotted">{{ currentUser?.email }}</span></label>
                <label class="email-link">ID: #<span class="dotted">{{ currentUser?.id }}</span>,
                  PBS ID: #<span class="dotted">{{ currentUser?.employeeId }}</span></label>
              </div>
              <div>
                <img *ngIf="currentUser?.photoUrl" [src]="currentUser?.photoUrl" class="img-thumbnail rounded-circle"
                     style="height: 50px; width: 50px; object-fit: cover" (error)="currentUser.photoUrl = ''"/>
                <img *ngIf="!currentUser?.photoUrl" appDealerIcon class="img-thumbnail rounded-circle"
                     style="height: 50px; width: 50px; object-fit: cover"/>
              </div>
            </div>
            <div style="margin-top:10px;">
              <button (click)="logout()">Logout</button>
            </div>
          </div>
          <mat-divider></mat-divider>
          <div class="sidenav-section first">
            <label class="section-head">Switch to Module:</label>
            <button *ngIf="currentUser?.dashboard" class="tool" (click)="showDashboard()">Dashboard</button>
            <button class="tool" mat-button (click)="modulePathLink('/clearpath/list')">Presentation</button>
            <a *ngIf="isSalesManager || isSysAdmin" class="tool" mat-button
               (click)="modulePathLink('/sales-manager/list')">Desking</a>
            <a *ngIf="isSysAdmin" class="tool" mat-button (click)="modulePathLink('/settings')">Administration</a>
            <a *ngIf="isSalesManager || isSysAdmin" class="tool" mat-button
               (click)="modulePathLink('/reports')">Reports</a>
          </div>
          <div class="sidenav-section">
            <label class="section-head">Tools:</label>
            <a class="tool" mat-button (click)="modulePathLink('/clearpath/new-deal')">Create Writeup</a>
            <a class="tool" mat-button (click)="closeUserSidenav()"
               href="https://www.routeone.net/digital-retail-ui/?dealerId=SY5CM&source=531vc4" target="_blank">Credit
              Check</a>
            <button *ngIf="isSalesManager || isSysAdmin" class="tool"
                    (click)="openGetInventoryDialog();appService.userSidenavOpened=false;">Import
              Inventory
            </button>
          </div>
          <ng-container *ngIf="currentUser?.devMode">
            <div class="sidenav-section">
              <label class="section-head">Development Tools:</label>
              <button class="tool" mat-button (click)="toggleDev()">{{ appService.devSidenavOpened ? 'Hide' : 'Show' }}
                Development Console
              </button>
            </div>
          </ng-container>
        </div>
      </mat-sidenav>
      <mat-sidenav-content #sidenavContent>
        <div *ngIf="currentUser" class="content-container">
          <app-navbar
            [currentRelease]="currentRelease"
            [currentUser]="currentUser"
            [currentRoute]="currentRoute">
          </app-navbar>
          <app-alert></app-alert>
          <div class="router-container">
            <router-outlet (activate)="onActivate($event)"></router-outlet>
          </div>
          <div class="router-shadow-container">
            <div class="router-shadow"></div>
          </div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </mat-sidenav-content>
</mat-sidenav-container>
<router-outlet name="modal"></router-outlet>
